package com.dotdrives.web.pages

import com.dotdrives.controller.AuthController
import com.dotdrives.controller.AuthUiState
import com.dotdrives.web.ui.DotBanner
import com.dotdrives.web.ui.DotButton
import com.dotdrives.web.ui.DotTextField
import react.FC
import react.Props
import react.dom.html.ReactHTML.a
import react.dom.html.ReactHTML.div
import react.dom.html.ReactHTML.form
import react.dom.html.ReactHTML.h1
import react.dom.html.ReactHTML.p
import react.dom.html.ReactHTML.span
import react.useState
import web.cssom.ClassName
import web.html.InputType
import web.html.password

external interface ResetPasswordPageProps : Props {
    var controller: AuthController
    var state: AuthUiState
    var onBackToSignIn: () -> Unit
}

val ResetPasswordPage = FC<ResetPasswordPageProps> { props ->
    val (password, setPassword) = useState("")
    val (confirmation, setConfirmation) = useState("")
    val (localError, setLocalError) = useState<String?>(null)

    fun submit() {
        val validationError = validateNewPassword(password, confirmation)
        setLocalError(validationError)
        if (validationError == null) {
            props.controller.updatePassword(password)
        }
    }

    div {
        className = ClassName("reset-page")
        div {
            className = ClassName("reset-card")
            a {
                href = "${kotlinx.browser.window.location.pathname}#/"
                ariaLabel = "Dot Drives home"
                className = ClassName("reset-brand dot-home-link")
                +"dot drives"
                span {
                    className = ClassName("signin-story-brand-period")
                    +"."
                }
            }
            if (!props.state.recoveryPending) {
                h1 {
                    className = ClassName("reset-title dot-heading")
                    +"This reset link is invalid or has expired"
                }
                p {
                    className = ClassName("reset-copy")
                    +"Request a new link from the sign-in page to try again."
                }
                a {
                    href = "#/signin"
                    className = ClassName("reset-back-link")
                    onClick = {
                        it.preventDefault()
                        props.onBackToSignIn()
                    }
                    +"← Back to sign in"
                }
            } else {
                h1 {
                    className = ClassName("reset-title dot-heading")
                    +"Choose a new password"
                }
                p {
                    className = ClassName("reset-copy")
                    +"Use at least 8 characters. You'll return to your portal after saving."
                }
                (localError ?: props.state.error)?.let { message ->
                    DotBanner {
                        this.message = message
                    }
                }
                form {
                    className = ClassName("reset-form")
                    onSubmit = {
                        it.preventDefault()
                        submit()
                    }
                    DotTextField {
                        value = password
                        onValueChange = {
                            setPassword(it)
                            setLocalError(null)
                        }
                        label = "New password"
                        type = InputType.password
                    }
                    DotTextField {
                        value = confirmation
                        onValueChange = {
                            setConfirmation(it)
                            setLocalError(null)
                        }
                        label = "Confirm password"
                        type = InputType.password
                    }
                    DotButton {
                        text = "Save new password"
                        onClick = ::submit
                        enabled = true
                        loading = props.state.loading
                        className = "dot-full-width"
                    }
                }
            }
        }
    }
}

internal fun validateNewPassword(password: String, confirmation: String): String? = when {
    password.length < 8 -> "Enter a password with at least 8 characters."
    password != confirmation -> "Passwords do not match."
    else -> null
}
